import { render, staticRenderFns } from "./AUsuariosSemaforo.vue?vue&type=template&id=2672ca23"
import script from "./AUsuariosSemaforo.vue?vue&type=script&lang=js"
export * from "./AUsuariosSemaforo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports